import React, { useState, useEffect } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Eye } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import useDebounce from "../utils/useDebounce";

export default function PasswordChange() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPass, setConfirmNewPass] = useState("");
  const [filledOut, setFilledOut] = useState(false);
  const [checkPassword, setCheckPassword] = useState(false);
  const [matchPassword, setMatchPassword] = useState(false);
  const [inputType, setInputType] = useState("password");

  function matchPasswordFunc(newPassword, confirmNewPass) {
    if (newPassword === confirmNewPass) {
      setMatchPassword(true);
    } else {
      setMatchPassword(false);
    }
  }

  function validatePassword(password) {
    setNewPassword(password);
    const minLength = 8;
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    if (password.length <= minLength) {
      setCheckPassword(false);
      return "length";
    }
    if (!hasNumber.test(password)) {
      setCheckPassword(false);
      return "number";
    }
    if (!hasSpecialChar.test(password)) {
      setCheckPassword(false);
      return "special";
    }
    if (
      password.length >= minLength &&
      hasNumber.test(password) &&
      hasSpecialChar.test(password)
    ) {
      setCheckPassword(true);

      return "passed";
    } else {
      setCheckPassword(false);

      return "failed";
    }
  }

  function ifFilled() {
    if (
      currentPassword != "" &&
      newPassword != "" &&
      confirmNewPass != "" &&
      checkPassword == true &&
      matchPassword == true
    ) {
      setFilledOut(true);
    } else {
      setFilledOut(false);
    }
  }

  function confirmPass(password) {
    setConfirmNewPass(password);
    matchPasswordFunc(newPassword, password);
  }

  // function newPassIput(password){
  //     debounce(validatePassword(password), 2000)
  // }

  function toggleInput() {
    if (inputType == "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  }

  const debouncedValidation = useDebounce(validatePassword, 1000);
  const debouncedMatch = useDebounce(confirmPass, 100);

  return (
    <>
      <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardHeader className="px-9 pt-6 pb-4">
              <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
                <div className="flex items-center">
                  <div>Update Password</div>
                </div>
              </CardTitle>
            </CardHeader>

            <CardContent className="px-5 pt-2  pb-6">
              <div className="columns-1 mb-6">
                <div className="relative w-full px-4">
                  <p className="text-[14px] text-text-secondary font-normal mb-2">
                    Current Password
                  </p>
                  <Eye
                    strokeWidth={1}
                    className="text-text-secondary absolute top-[69%] transform -translate-y-1/2 right-9"
                    onClick={() => {
                      toggleInput();
                    }}
                  />
                  <input
                    type={inputType}
                    placeholder="Current Password"
                    //value={name}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    onBlur={() => ifFilled()}
                    className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                  />
                </div>
              </div>
              <div className="columns-1 mb-6">
                <div className="relative w-full px-4">
                  <p className="text-[14px] text-text-secondary font-normal mb-2">
                    New password
                  </p>
                  <input
                    type="text"
                    placeholder="New Password"
                    //value={name}
                    onChange={(e) => debouncedValidation(e.target.value)}
                    onBlur={() => ifFilled()}
                    className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                  />
                </div>
              </div>
              <div className="columns-1 mb-6">
                <div className="relative w-full px-4">
                  <p className="text-[14px] text-text-secondary font-normal mb-2">
                    Confirm new password
                  </p>
                  <input
                    type="text"
                    placeholder="Confirm new password"
                    //value={name}
                    onChange={(e) => debouncedMatch(e.target.value)}
                    onBlur={() => ifFilled()}
                    className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
                  />
                </div>
              </div>
              <div className="flex justify-center">
                <button
                  disabled={!filledOut}
                  className="bg-inherit border-[1px] border-bg-neutral text-text-secondary text-[14px] disabledfont-semibold py-2 rounded-full w-[50%] hover:"
                  onClick={() => {}}
                >
                  Save
                </button>
              </div>
            </CardContent>
            <Separator />
            <div className="py-4 text-center text-sm text-gray-500">
              Need to resecure your account?{"  "}
              <a href="#" className="text-rose-600 font-bold hover:underline">
                Reset Password
              </a>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
